import React, { useEffect, useState } from 'react';
import { useMemo } from 'react';
import ReactSelect from 'react-select';
import { useEntityCrud } from '../../hooks/useEntityCrud';
import { useNavigate, useLocation } from 'react-router-dom';
import { toast } from 'react-toastify';


const SearchGroup = ({ formik, groupList, setGroupList, businessList, orgAddress, setOrgAddress, modeShow,
    data, setData,
    setModeShow, mode, setMode, filterBTN, setFilterBTN }) => {


    const navigate = useNavigate();

    const [storageItemBusiness, setStorageItemBusiness] = useState([])
    const [storageItemGroup, setStorageItemGroup] = useState([])


    const { readDataByFilter: readDataGroup } = useEntityCrud('Group/GetAllGroups')

    const businessAll = useMemo(() => businessList
        .map(item => ({ value: item.id, label: item.title, isActive: item.isActive })));
    const groupAll = useMemo(() => groupList
        .map(item => ({ value: item.id, label: item.title, isActive: item.isActive })))

    useEffect(() => {

        const postedData = {
            buisnessId: parseInt(localStorage.getItem("searchDetailsBuinessID")) ? parseInt(localStorage.getItem("searchDetailsBuinessID")) : orgAddress.buisnessId.value,
        };
        readDataGroup(postedData).then(res => {
            setGroupList(res.data.result)
        });
    }, [businessList, orgAddress?.buisnessId?.value])


    const handleChangeBusiness = (value) => {

        localStorage.removeItem("searchDetailsBuinessID");
        localStorage.removeItem("searchDetailsGroupID");

        setOrgAddress(prevState => ({ ...prevState, groupId: "" }))
        setOrgAddress(prevState => ({ ...prevState, buisnessId: value }))

        setStorageItemGroup({
            value: "",
            label: ""
        })

        setData([])

    }

    const handleChangeGroup = (value) => {

        localStorage.removeItem("searchDetailsGroupID");

        setOrgAddress(prevState => ({ ...prevState, groupId: value }))

        setData([])
    }


    useEffect(() => {

        const searchDetailsBusinessId = parseInt(localStorage.getItem("searchDetailsBuinessID"));
        setStorageItemBusiness({
            value: businessAll?.find(it => it.value === searchDetailsBusinessId),
            label: businessAll?.find(it => it.value === searchDetailsBusinessId)?.label
        })

        const searchDetailsGroupId = parseInt(localStorage.getItem("searchDetailsGroupID"));
        setStorageItemGroup({
            value: groupAll?.find(it => it.value === searchDetailsGroupId),
            label: groupAll?.find(it => it.value === searchDetailsGroupId)?.label
        })

    }, [localStorage.getItem("searchDetailsBuinessID"), localStorage.getItem("searchDetailsGroupID"), businessList, groupList])


    /*     const filterData = () => {
             
            orgAddress.buisnessId = "";
            orgAddress.groupId = "";
            localStorage.removeItem("searchDetailsBuinessID");
            localStorage.removeItem("searchDetailsGroupID");
            setFilterBTN(false)
        }
     */

    return (
        <form onSubmit={formik.handleSubmit}>
            <div className="row mb-4">
                <div className="row" style={{ flex: "1", width: "80%" }}>
                    <div className="col-md-3">
                        {(orgAddress?.buisnessId?.value || localStorage.getItem("searchDetailsBuinessID")) &&
                            <i className="fe fe-x clear-select-btn"
                                style={{
                                    position: "absolute", top: "40px"
                                }}
                                onClick={e => {
                                    setData([])
                                    localStorage.removeItem("searchDetailsBuinessID");
                                    localStorage.removeItem("searchDetailsGroupID");
                                    setOrgAddress({
                                        buisnessId: "",
                                        groupId: ""
                                    })
                                }
                                }></i>}
                        <label>
                            کسب و کار
                        </label>
                        <ReactSelect label="   کسب و کار"
                            options={businessAll.filter(item => item.isActive === true)}
                            value={orgAddress.buisnessId || storageItemBusiness}
                            onChange={handleChangeBusiness}
                            placeholder="انتخاب کنید"
                            name="buisnessId"
                        />
                    </div>
                    <div className="col-md-3">
                        {(orgAddress?.groupId?.value || localStorage.getItem("searchDetailsGroupID")) && <i
                            style={{
                                position: "absolute", top: "25px"
                            }}
                            className="fe fe-x clear-select-btn mt-4" onClick={e => {
                                setData([])
                                localStorage.removeItem("searchDetailsGroupID");
                                setOrgAddress({
                                    groupId: ""
                                })
                            }
                            }></i>}
                        <label>
                            گروه
                        </label>
                        <ReactSelect label=" گروه"
                            options={groupAll.filter(item => item.isActive === true)}
                            placeholder="انتخاب کنید"
                            name="groupId"
                            value={orgAddress.groupId || storageItemGroup}
                            onChange={handleChangeGroup}
                        />
                    </div>
                    <div className='col-md-3 mt-4 pt-3'>
                        <button className="btn btn-success">نمایش اطلاعات</button>
                        {/*                         {filterBTN && <button className="btn btn-danger mx-2" onClick={() => filterData()}>حذف اطلاعات</button>}
 */}
                    </div>
                </div>


            </div>
        </form >
    );
}

export default SearchGroup;